import React from 'react';

import {
  Button as AntButton,
  type ButtonProps as AntButtonProps,
} from 'antd-v5';

// global overrides
import '../scss/_button.scss';
// local custom styles
import styles from './Button.module.scss';

const Button = AntButton as React.ForwardRefExoticComponent<
  ButtonProps & React.RefAttributes<HTMLButtonElement | HTMLAnchorElement>
>;

Button.defaultProps = {
  shape: 'round',
  type: 'primary',
};

export interface ButtonProps extends Omit<AntButtonProps, 'color'> {
  color?: AntButtonProps['color'] | 'white';
}

export const ToolbarButton: React.FC<ButtonProps> = props => (
  <Button className={styles.toolbarButton} {...props} type="text" />
);

/** Text button for dark toolbars, e.g. the roster grey bar */
export const DarkToolbarButton = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  ButtonProps
>(function DarkToolbarButton(props, ref) {
  return (
    <Button color="white" variant="text" shape="default" {...props} ref={ref} />
  );
});

export const IconButton: React.FC<
  ButtonProps & { icon: Required<ButtonProps['icon']>; shape?: 'circle' }
> = props => <Button {...props} shape="circle" />;

export default Button;
